module.exports = __webpack_public_path__ + "img/jlqc.626fab58.png";